import { render } from "./PagamentosRecebimentos.vue?vue&type=template&id=cfc4a9d4"
import script from "./PagamentosRecebimentos.vue?vue&type=script&lang=js"
export * from "./PagamentosRecebimentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__